import React, { useState, useEffect } from "react";
import { Button, Select } from "antd";
import { baseURL } from "../../../utils/config";
import { useSelector } from "react-redux";
import { getAvatarColor, getInitials } from "../../../utils/helpers";
import { api } from "../../global/api";

const TeamEditModal = ({
  handleCancel,
  handleOk,
  formData,
  setformData,
  originalFormData,
  changeHandeler,
  fetchData,
  setLoading,
  loading,
  handleSubmit
}) => {
  const [owner, setOwner] = useState([]);
  const [ownerError, setOwnerError] = useState(false);
  const okrSlice = useSelector((state) => state.okr);
  const currentUser = useSelector((state) => state.user?.currentUser);
  const user = useSelector((state) => state?.user);
  const currentCompany = useSelector((state) => state.user?.currentCompany);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const currentEmployee = currentUser?.employees;
        let company_id;
        if (currentEmployee && currentEmployee.length) {
          const currentCompanyIndex = user?.currentCompany;
          company_id = currentEmployee[currentCompanyIndex]?.company_id;
        }
        const response = await api.get(baseURL + "/employee_details/", {
          company_id: company_id,
        });
        setOwner(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  // new

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   const changes = {};
  //   Object.keys(formData).forEach((key) => {
  //     if (
  //       key !== "team_id" &&
  //       key !== "members" &&
  //       formData[key] !== originalFormData[key]
  //     ) {
  //       changes[key] = formData[key];
  //     }
  //   });

  //   if (formData?.members !== originalFormData?.members) {
  //     changes.users = formData?.members;
  //   }
  //   try {
  //     const currentEmployee = currentUser?.employees;
  //     const currentCompanyIndex = user?.currentCompany;
  //     const res = await api.put(baseURL + "/create-team/", {
  //       team_id: formData?.team_id,
  //       company_id: currentEmployee[currentCompanyIndex]?.company_id,
  //       ...changes,
  //     });
  //     if (res?.status === 200) {
  //       toast.success("Team Updated Successfully");

  //       setTimeout(() => {
  //         toast.dismiss();
  //         fetchData();
  //         handleCancel();
  //       }, 1000);
  //     } else {
  //       toast.error("Please Try Again");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     toast.error("Please Try Again");
  //   }

  //   setLoading(false);
  // };

  return (
    <div>
      <form
        className="'w-full flex flex-col py-3 px-3 gap-y-4"
        onSubmit={handleSubmit}
      >
        <div className="flex flex-col items-start w-full gap-y-2">
          <h1 className="p-1 text-3xl font-bold text-black">Update team</h1>
          <p className="p-1 text-gray-600">
            All required fields are marked with an asterisk (*).
          </p>
        </div>

        {/* {showBelowDiv && ( */}
        <div className="w-full grid grid-cols-6 gap-x-6 py-2 my-3 gap-y-6 items-center max-h-[350px] overflow-y-auto">
          <label className="col-span-2 text-sm">Name*</label>

          <div className="col-span-4 ">
            <input
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-lg"
              type="text"
              name="team_name"
              id="team_name"
              maxLength={25}
              onChange={(e) => {
                const value = e.target.value;
                if (
                  value !== " " &&
                  /[a-zA-Z0-9]/.test(value) &&
                  !/^[\s]+$/.test(value)
                ) {
                  changeHandeler(e);
                } else if (value === "") {
                  changeHandeler(e);
                }
              }}
              value={formData?.team_name}
              placeholder=""
              required
            />
          </div>

          <label className="col-span-2 text-sm">Members</label>
          <div className="col-span-4 ">
            <Select
              name="members"
              id="members"
              onChange={(val) => {
                const selectedMembers = val.map((userId) => {
                  const selectedOwner = owner.find((o) => o.user_id === userId);
                  return {
                    user_id: userId,
                    role_id: selectedOwner?.role || null,
                  };
                });
                setformData({ ...formData, members: selectedMembers });
                setOwnerError(false);
              }}
              value={formData?.members?.map((member) => member?.user_id)}
              mode="multiple"
              required
              filterOption={(input, option) =>
                owner
                  ?.find((o) => o.user_id === option.value)
                  ?.username.toLowerCase()
                  .includes(input.toLowerCase())
              }
              className="w-full"
              placeholder="Select Member"
              tagRender={({ label, value, onClose }) => {
                const selectedOwner = owner.find((o) => o.user_id === value);
                if (!selectedOwner) return null;

                return (
                  <div className="flex items-center gap-x-2 mr-2 bg-gray-100">
                    <div
                      className="w-5 h-5 text-sm border border-black rounded-full flex items-center justify-center text-white relative"
                      style={{
                        backgroundColor: selectedOwner?.profile_image
                          ? "initial"
                          : getAvatarColor(selectedOwner?.username),
                      }}
                    >
                      {selectedOwner?.profile_image ? (
                        <img
                          src={selectedOwner?.profile_image}
                          alt="Profile"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                            display: "block",
                          }}
                        />
                      ) : (
                        getInitials(selectedOwner?.username)
                      )}
                    </div>
                    <span>{selectedOwner?.username || value}</span>
                    <button onClick={onClose} className="ml-2">
                      &times;
                    </button>
                  </div>
                );
              }}
            >
              {owner?.map((owner, index) => (
                <Select.Option key={index} value={owner?.user_id}>
                  <div className="flex items-center gap-x-2">
                    <div
                      className="w-5 h-5 text-sm border border-black rounded-full flex items-center justify-center text-white relative"
                      style={{
                        backgroundColor: owner?.profile_image
                          ? "initial"
                          : getAvatarColor(owner?.username),
                      }}
                    >
                      {owner?.profile_image ? (
                        <img
                          src={owner?.profile_image}
                          alt="Profile"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                            display: "block",
                          }}
                        />
                      ) : (
                        getInitials(owner?.username)
                      )}
                    </div>
                    <span>{owner?.username}</span>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </div>

          <div className="flex gap-5">
            <Button
              loading={loading}
              type="primary"
              onClick={handleOk}
              htmlType="submit"
            >
              Update Team
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
          </div>
        </div>
        {/* )} */}
      </form>
    </div>
  );
};

export default TeamEditModal;
